import {defineMessages} from 'react-intl';

export default defineMessages({
	returnStatusSelect: {
		id: 'flyout.myAccount.orders.returnStatusSelect',
		defaultMessage: 'Select product to return / exchange',
	},
	returnStatusRefund: {
		id: 'flyout.myAccount.orders.returnStatusRefund',
		defaultMessage: 'Select refund method',
	},
	returnStatusView: {
		id: 'flyout.myAccount.orders.returnStatusView',
		defaultMessage: 'Return review',
	},
});
